import { render, staticRenderFns } from "./StockPrint8.vue?vue&type=template&id=6922ecfa&scoped=true&"
import script from "./StockPrint8.vue?vue&type=script&lang=js&"
export * from "./StockPrint8.vue?vue&type=script&lang=js&"
import style0 from "./StockPrint8.vue?vue&type=style&index=0&id=6922ecfa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6922ecfa",
  null
  
)

export default component.exports